export default {
	title: "Products",
	tabs: {
		allProducts: "All products",
		inventory: "Inventory",
		collection: "Collection",
		priceList: "Price list",
	},
	table: {
		product: "Product",
		details: "Details",
		quantity: "Quantity",
		price: "Price",
		supplement: "Supplement"
	},
	allProducts: {
		paginatorText: "products",
		addProduct: "Add Product",
		search: "Search Products",
		chooseCategory: "Choose Category",
		chooseStatus: "Choose Status",
        allCategories: "All Categories",
        allStatuses: "All Statues",
		table: {
			isSelected: "selected", // ToDo check if in use
			product: "Product",
			quantity: "Quantity",
			category: "Category",
			active: "Active",
			vendor: "Vendor",
            in: "in",
            variants: "variants"
		},
        statuses: {
            allStatuses: "All Statuses",
            allCategories: "All Categories",
            active: "Active",
            inactive: "Inactive",
            scheduled: "Scheduled"
        },
        activateSuccessMessage: "Products have been activated successfully.",
        deactivateSuccessMessage: "Products have been deactivated successfully.",
        deleteMultipleSuccessMessage: "Products have been deleted successfully.",
        deleteSuccessMessage: "Product has been deleted successfully."
    },
	inventory: {
		paginatorText: "products and variants",
		search: "Search Inventory",
		chooseCategory: "Choose Category",
		chooseStatus: "Choose Status",
        allStatuses: "All Statuses",
        allCategories: "All Categories",
		table: {
			productAndVariants: "Product and Variants",
			isSelected: "selected", // ToDo check if in use
			category: "Category",
			active: "Active",
			token: "Token",
			price: "Price",
			cancel: "Cancel",
			save: "Save",
			edit: "Edit",
		},
        statuses: {
            active: "Active",
            inactive: "Inactive",
            scheduled: "Scheduled"
        },
		paginationError: "Changes won't be saved.",
	},
	collections: {
		paginatorText: "collections",
		addCollection: "Add Collection",
		search: "Search Collections",
		table: {
			name: "Name",
			quantity: "Quantity",
			active: "Active",
			createdAt: "Created"
		},
        statuses: {
            allStatuses: "All Statuses",
            allCategories: "All Categories",
            active: "Active",
            inactive: "Inactive",
            scheduled: "Scheduled"
        },
        activateSuccessMessage: "Collections have been activated successfully.",
        deactivateSuccessMessage: "Collections have been deactivated successfully.",
        deleteMultipleSuccessMessage: "Collections have been deleted successfully.",
	},
};
